<template>
  <v-content>
    <v-container fluid>
      <v-layout>
        <v-flex>

          <OLoadingDialog :value="isLoading"/>

          <v-card>
            <v-toolbar flat class="card-bar">
              <v-toolbar-title>Rawdata Parser</v-toolbar-title>
            </v-toolbar>

            <v-card-text>
              <v-textarea
                class="monospace-input"
                v-model="rawdata"
                label="Rawdata (hex)"/>
            </v-card-text>
            <v-card-actions>
              <span class="mr-4" style="max-width: 200px">
                <v-text-field label="Firmware Version (hex)"
                  prefix="0x"
                  v-model="fwVersion"/>
              </span>
              <span class="mr-4" style="max-width: 200px">
                <v-switch label="newAsciiFormat"
                  v-model="newAsciiFormat"/>
              </span>
              <v-btn color="primary" large
                @click="parse()">Parse</v-btn>
              <v-spacer/>
            </v-card-actions>
          </v-card>

          <RawdataDisplay class="mt-4"
            v-if="parsedData != null"
            :data="parsedData"/>

        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import _ from 'lodash'
import Slicer from 'horus-parser/src/Slicer'
import brush from 'brush'
import {Org, OrgApi, Heartbeat} from '../../models'
import RawdataDisplay from './RawdataDisplay.vue'
import OLoadingDialog from 'oderon-vue/cpts/OLoadingDialog'

export default {
  components: {RawdataDisplay, OLoadingDialog},
  data() {
    return {
      isLoading : false,
      rawdata   : ``,
      parsedData: null,
      fwVersion: '02',
      newAsciiFormat: true
    }
  },
  computed: {
    oid()   { return +this.$route.query.oid || null },
    tid()   { return +this.$route.query.tid || null },
    hbid()  { return +this.$route.query.hbid || null },
    shouldFetch() {
      return (this.oid != null && this.tid != null) || this.hbid != null
    }
  },
  watch: {
    $route() { this.fetchIfNecessary() }
  },
  mounted() { this.fetchIfNecessary() },
  methods: {
    fetchIfNecessary() {
      if ( !this.shouldFetch ) return

      this.$loading(async () => {
        await this.fetchData()
        this.parse()
      })
    },
    fetchData() {
      if ( this.oid != null && this.tid != null )
        return this.fetchTripRawdata()

      if ( this.hbid != null )
        return this.fetchHbRawdata()
    },
    async fetchTripRawdata() {
      let org = await Org.findById(this.oid),
          proxy = new OrgApi(org)

      this.rawdata = await proxy.get(`//trips/${this.tid}/rawdata`)
    },
    async fetchHbRawdata() {
      let hb = await Heartbeat.findById(this.hbid),
          measure = _.find(hb.measures, {measureType: 'raw_data'})
      this.rawdata = _.get(measure, 'rawContents') || ''
    },
    parse() {
      let bytes = brush.hexToBytes(this.rawdata),
          slicer = new Slicer(bytes, {
            startPointer      : 0,
            keepBytesInLapses : true,
            keepBytesInFrames : true,
            newAsciiFormat    : this.newAsciiFormat,
            lastFwVersion     : parseInt(this.fwVersion, 16),
            supportCanSniff: true
          })

      this.parsedData = slicer.slice()
      // console.log(this.parsedData)

      // Ajusta cada frame para ter o .payload e o .bytes
      this.parsedData.frames.forEach(f => {
        if (f.type == 'event') f.payload = f.event
        if (f.type == 'header') f.payload = f.header
        if (f.type == 'footer') f.payload = f.footer
        if (f.type == 'lapses') f.payload = f.lapses
        if (f.type == 'garbage') f.payload = {}
        if ( f.type == 'sniff') f.payload = f

        if (f.type != 'lapses') f.payload.bytes = f.bytes
      })
    }
  }
}
</script>

<style>
</style>
